import React from 'react'
import { CVRCompanyDetails } from '../../types'
import {
  formatAddressCountryLabel,
  formatCompanyAddress,
  formatCompanyForm,
  formatDate,
} from '../../utils/format'
import { DataRow, Section } from '../ui'

interface StamdataProps {
  company: CVRCompanyDetails
}

function formatWebsiteHref(url: string): string {
  const trimmed = url.trim()
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  return `https://${trimmed}`
}

const Stamdata: React.FC<StamdataProps> = ({ company }) => {
  const rows: Array<[string, React.ReactNode]> = []
  const fullAddress = formatCompanyAddress(company)

  if (fullAddress) {
    rows.push(['Adresse', formatAddressCountryLabel(fullAddress)])
  }
  if (company.virksomhedsform) {
    rows.push(['Virksomhedsform', formatCompanyForm(company.virksomhedsform) ?? company.virksomhedsform])
  }
  if (company.branche) rows.push(['Branche', company.branche])
  if (company.telefon) rows.push(['Telefon', company.telefon])
  if (company.email) {
    rows.push([
      'E-mail',
      <a
        href={`mailto:${company.email}`}
        className="text-ink hover:underline decoration-signal underline-offset-2"
      >
        {company.email}
      </a>,
    ])
  }
  if (company.hjemmeside) {
    const href = formatWebsiteHref(company.hjemmeside)
    rows.push([
      'Hjemmeside',
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-ink hover:underline decoration-signal underline-offset-2 break-all"
      >
        {company.hjemmeside}
      </a>,
    ])
  }
  if (company.binavne && company.binavne.length > 0) {
    rows.push(['Binavne', company.binavne.join(', ')])
  }
  if (company.reklamebeskyttet !== undefined) {
    rows.push(['Reklamebeskyttelse', company.reklamebeskyttet ? 'Ja' : 'Nej'])
  }
  if (company.produktionsenhederAntal !== undefined && company.produktionsenhederAntal > 0) {
    rows.push(['Produktionsenheder', String(company.produktionsenhederAntal)])
  }
  if (company.sidstOpdateret) {
    rows.push(['Sidst opdateret i CVR', formatDate(company.sidstOpdateret)])
  }

  if (rows.length === 0) return null

  return (
    <Section title="Stamdata" compact>
      <dl>
        {rows.map(([label, value]) => (
          <DataRow key={label} label={label} compact>
            {value}
          </DataRow>
        ))}
      </dl>
    </Section>
  )
}

export default Stamdata
